import { setYear, setAltitude } from '../altitudes';

const { ceil } = Math;

const makeWithinBounds = (value, min, max) => {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
};

/**
 * Set altityde by altitude.
 * @param {!number} altitude Year.
 * @return {function} action dispatcher.
 */
export default (altitude) => (dispatch, getState) => {
  const { altitudes } = getState();

  let index = altitudes.all.findIndex(({ value }) => value >= altitude);

  if (index === -1) {
    return;
  }

  if (index === 0) {
    index = 1;
  }

  const prev = altitudes.all[index - 1];
  const next = altitudes.all[index];

  const percentage = (altitude - prev.value) / (next.value - prev.value);
  const year = ceil(prev.year + (next.year - prev.year) * percentage);

  const max = altitudes.all[altitudes.all.length - 1];
  const min = altitudes.all[0];

  dispatch(setYear(makeWithinBounds(year, min.year, max.year)));
  dispatch(setAltitude(makeWithinBounds(altitude, min.value, max.value)));
};
